
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"27","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M23.939 14c0 .468-.041.908-.096 1.348l2.902 2.27c.262.207.33.578.166.88l-2.752 4.761c-.165.303-.523.426-.84.303l-3.425-1.376a10.57 10.57 0 01-2.325 1.348l-.522 3.646a.67.67 0 01-.675.578H10.87a.67.67 0 01-.674-.578l-.522-3.646a10.05 10.05 0 01-2.325-1.348l-3.426 1.376c-.303.11-.674 0-.84-.303l-2.75-4.76a.694.694 0 01.164-.88l2.903-2.27A10.91 10.91 0 013.303 14c0-.454.041-.908.096-1.348l-2.903-2.27a.678.678 0 01-.165-.88l2.752-4.76a.671.671 0 01.839-.303l3.426 1.376a10.57 10.57 0 012.325-1.349l.522-3.645a.67.67 0 01.674-.578h5.503a.67.67 0 01.675.578l.522 3.645c.84.344 1.61.798 2.325 1.349l3.426-1.376c.303-.11.674 0 .84.302l2.75 4.76a.694.694 0 01-.165.881l-2.902 2.27c.055.44.096.88.096 1.348zM8.806 14a4.82 4.82 0 004.815 4.815A4.82 4.82 0 0018.436 14a4.82 4.82 0 00-4.815-4.815A4.82 4.82 0 008.806 14z"}})])
          )
        }
      }
    